export const TASK_CONTENT_MAX_WIDTH = 756;
